export default {
  master_title: 'Tryb marki - Menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Przypisz numery produktów',
      tooltip:
        'Automatycznie przypisuje numery produktom na podstawie ich pozycji w menu. Numer jest drukowany na paragonach',
    },
  },
  buttons: {
    new_menu: 'Nowe menu',
    export_menu: 'Eksportuj menu',
    refresh: 'Odśwież',
  },
  modals: {
    delete_category: {
      title: 'Usuń {{name}}',
    },
    delete_products: {
      title: 'Usunąć {{count}} produktów?',
      description: '<strong>{{count}}</strong> zostanie usuniętych z menu',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_delete_menu: 'Nie udało się usunąć menu, spróbuj ponownie',
    menu_got_deleted: 'Menu zostało usunięte',
    failed_to_delete_category: 'Nie udało się usunąć kategorii, spróbuj ponownie',
    category_got_deleted: 'Kategoria została usunięta',
    failed_to_delete_products: 'Nie udało się usunąć produktów, spróbuj ponownie',
    product_got_deleted_one: 'Produkt został usunięty',
    product_got_deleted_few: 'Produkty zostały usunięte',
    product_got_deleted_many: 'Produkty zostały usunięte',
    product_got_deleted_other: 'Produkty zostały usunięte',
    failed_to_generate_product_number: 'Coś poszło nie tak. Odśwież stronę i spróbuj ponownie',
    menu_exported: 'Menu zostało wyeksportowane',
    failed_to_export_menu: 'Nie udało się wyeksportować menu',
  },
};
